import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createTheme, MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import { ErrorApi } from './api';
import { ProveedorSesion } from './sesion';
import { App } from './App';

dayjs.locale('es');

const tema = createTheme({
  primaryColor: 'verde',
  colors: {
    verde: ['#eef7f4', '#dcebe6', '#b5d6cb', '#8bc0af', '#68ad97', '#52a188', '#459b80', '#36866d', '#2f6b5f', '#1f5a4c'],
  },
  fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  defaultRadius: 'md',
});

const clienteConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (n, e) => !(e instanceof ErrorApi && e.estado < 500) && n < 2,
      refetchOnWindowFocus: true,
    },
  },
});

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <MantineProvider theme={tema} defaultColorScheme="auto">
      <DatesProvider settings={{ locale: 'es', firstDayOfWeek: 1 }}>
        <ModalsProvider labels={{ confirm: 'Aceptar', cancel: 'Cancelar' }}>
          <Notifications position="top-right" />
          <QueryClientProvider client={clienteConsultas}>
            <BrowserRouter>
              <ProveedorSesion>
                <App />
              </ProveedorSesion>
            </BrowserRouter>
          </QueryClientProvider>
        </ModalsProvider>
      </DatesProvider>
    </MantineProvider>
  </StrictMode>,
);
